import { render, staticRenderFns } from "./WarehouseSummary.vue?vue&type=template&id=722eda8f&scoped=true&"
import script from "./WarehouseSummary.vue?vue&type=script&lang=js&"
export * from "./WarehouseSummary.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseSummary.vue?vue&type=style&index=0&id=722eda8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722eda8f",
  null
  
)

export default component.exports